export default "__VITE_ASSET__CKgXTsee__"